import React, { Component } from 'react';
import { Link, useLocation } from 'react-router-dom'
import { DropdownButton, Dropdown, Button } from 'react-bootstrap';

import mainlogo from './img/logo500.png';
import whitelogo from './img/whitelogo.png';


export const  Menu = ({props})=>  {
	
	const location = useLocation();
	
		return (
			<header className="App-header">
 <nav className="navbar navbar-default navbar-fixed-top">
       <div className="container-fluid">
       <div className="navbar-header navbar-right">

			<div>
			{(location.pathname == '/') ? <p></p> :
				<div className="navbar-brand Menuleft">

				<Link to="/" >

					<img src={mainlogo} className = "logoimage img-responsive img-rounded"/>
					</Link>
				</div>}
<nav className="navbar d-sm-none">
	{(location.pathname == '/')  ?
		<div>
	<img src={mainlogo} className = "logoimage img-responsive img-rounded"/>
	<img src={whitelogo} className = "whitelogo img-responsive img-rounded"/>
	</div>
	: <div></div> }
	<div className="float-right">
<DropdownButton className="dropdown-menu-right float-sm-right float-right" variant="flat" id="dropdown-basic-button" title="Menu">

<Dropdown.Item>

	Kid Apps

</Dropdown.Item>
<Dropdown.Item>
	<Link to="/wobblyabc" className = "menuIcon" activeClassName="selected">
	WobblyABC
	</Link>
</Dropdown.Item>

<Dropdown.Item>
	<Link to="/burpcow" className = "menuIcon" activeClassName="selected">
	Burp the Cow
	</Link>
</Dropdown.Item>
<Dropdown.Item>
	<Link to="/floatywords" className = "menuIcon" activeClassName="selected">
	Floaty Words
	</Link>
</Dropdown.Item>

<Dropdown.Item>
	<Link to="/wobblyabc" className = "menuIcon" activeClassName="selected">
	Wobbly ABC
	</Link>
</Dropdown.Item>


 <Dropdown.Divider />
 <Dropdown.Item>

 	Adult Apps

 </Dropdown.Item>
 <Dropdown.Item>
 	<Link to="/auditattack" className = "menuIcon" activeClassName="selected">
 	Audit Attack
 	</Link>
 </Dropdown.Item>
 <Dropdown.Item>
 	<Link to="/auditattacktwo" className = "menuIcon" activeClassName="selected">
 	Audit Attack Two
 	</Link>
 </Dropdown.Item>
 <Dropdown.Divider/>
 <Dropdown.Item>

 About Us

 </Dropdown.Item>
 <Dropdown.Item>
	 <Link to="/aboutus" className = "menuIcon" activeClassName="selected">
	 About Us
	 </Link>
 </Dropdown.Item>
 <Dropdown.Item>
	 <Link to="/privacy" className = "menuIcon" activeClassName="selected">
	 Privacy Policy
	 </Link>
 </Dropdown.Item>

</DropdownButton>
</div>

</nav>

	<nav className="navbar navbar-expand-sm Menu">

		<div className="collapse navbar-collapse">

			<ul className="navbar-nav mr-auto">

				<li className="nav-item">
	<DropdownButton variant="flat" id="dropdown-basic-button" title="Kid Apps">
	<Dropdown.Item>
		<Link to="/wobblyabc" className = "menuIcon" activeClassName="selected">
		Wobbly ABC
		</Link>
	</Dropdown.Item>
	
	<Dropdown.Item>
		<Link to="/burpcow" className = "menuIcon" activeClassName="selected">
		Burp the Cow
		</Link>
	</Dropdown.Item>
	<Dropdown.Item>
		<Link to="/floatywords" className = "menuIcon" activeClassName="selected">
		Floaty Words
		</Link>
	</Dropdown.Item>

	
	


	</DropdownButton>
				</li>
				<li className="nav-item">
				<DropdownButton variant="flat" id="dropdown-basic-button" title="Adult Apps">

  	<Dropdown.Item>
			<Link to="/auditattack" className = "menuIcon" activeClassName="selected">
			Audit Attack
			</Link>
		</Dropdown.Item>
		<Dropdown.Item>
			<Link to="/auditattacktwo" className = "menuIcon" activeClassName="selected">
			Audit Attack Two
			</Link>
		</Dropdown.Item>
	</DropdownButton>
				</li>
				<li className="nav-item">
				<DropdownButton variant="flat" id="dropdown-basic-button" title="About Us">

		<Dropdown.Item>
			<Link to="/aboutus" className = "menuIcon" activeClassName="selected">
			About Us
			</Link>
		</Dropdown.Item>
		<Dropdown.Item>
			<Link to="/privacy" className = "menuIcon" activeClassName="selected">
			Privacy Policy
			</Link>
		</Dropdown.Item>
		
	</DropdownButton>
				</li>
			</ul>
		</div>


	</nav>
</div>
</div>
        </div>
       </nav>
           </header>
)

}


